/* eslint-disable */
import { LibCategories } from "src/utils/consent";
import { loadScript } from "src/utils/scriptLoader";

declare let _paq: any[];
declare const window: Window & {
  _paq: any;
};

window._paq = window._paq || [];
_paq.push(["trackPageView"]);
_paq.push(["enableLinkTracking"]);

export function loadTag4Arm() {
  const protocol = document.location.protocol === "https:" ? "https" : "http";
  const u = `${protocol}://www.tag4arm.com/tags4arm/`;
  _paq.push(["setTrackerUrl", `${u}tag4arm.php`]);
  _paq.push(["setSiteId", "457"]);
  return loadScript(
    `${u}tag4arm.js`,
    [LibCategories.performanceCookies, LibCategories.targetingCookies],
    { enableCORS: false }
  );
}

export function fpdTrackPurchase(revenue: string, customerID: string) {
  //The variables will need to be amended to correctly reflect GTM
  // #Track Purchase confirmation
  _paq.push(["setCustomVariable", "1", "EventType", "Purchase", "page"]);
  _paq.push(["setCustomVariable", "2", "Revenue", revenue, "page"]); //The 'revenue' will need to be amended to reflect the correct variable in GTM
  _paq.push(["setCustomVariable", "3", "CustomerID", customerID, "page"]); //The 'customerID' will need to be amended to reflect the correct variable in GTM
  _paq.push(["trackPageView"]);
}

export function fpdTrackSurveyResponse(surveyResponse: string) {
  //The variables will need to be amended to correctly reflect GTM
  // #Track Survey Response
  _paq.push(["setCustomVariable", "1", "EventType", "Survey", "page"]);
  _paq.push([
    "setCustomVariable",
    "2",
    "SurveyResponse",
    surveyResponse,
    "page",
  ]); //The 'surveyresponse' will need to be amended to reflect the correct variable in GTM
  _paq.push(["trackPageView"]);
}
